import type { ReactElement } from "react";
import { StyledDropdownLabelGapWrapped } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalsDropdownLabel/styles";
import { StyledInlineFilterWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import { translate } from "app/filters/i18nFilter";
import { StyledTechnologiesSignalFiltersWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/views/TechnologySignalFiltersView/styles";
import SignalPeriodsFilter from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalPeriodsFilter/SignalPeriodsFilter";
import type { TechnologySignalFilterViewProps } from "app/pages/sales-intelligence/sub-modules/signals/components/views/TechnologySignalFiltersView/models/TechnologySignalFilterViewProps";
import type TechnologyChangesPeriod from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesPeriod";
import {
    technologyRenewalPeriodOptions,
    technologyRenewalPeriodToValue,
    technologyRenewalValueToPeriod,
} from "app/pages/sales-intelligence/sub-modules/signals/constants/technology";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

const CompetitorRenewalComingUpView = ({
    children,
    signalAlias,
    selectedValue,
    onValueChange,
}: TechnologySignalFilterViewProps): ReactElement => {
    const handlePeriodChange = (item: TechnologyChangesPeriod) => {
        trackingService.filters.trackTractionPeriodChange(item, signalAlias);
        onValueChange({ periodAmount: technologyRenewalPeriodToValue[item] });
    };

    return (
        <StyledTechnologiesSignalFiltersWrapper>
            <StyledDropdownLabelGapWrapped data-automation="technology-filter-text">
                {translate("si.signals.management.label.technology.filter-text")}
            </StyledDropdownLabelGapWrapped>
            <StyledInlineFilterWrapper>
                <SignalPeriodsFilter<TechnologyChangesPeriod>
                    selectedValue={technologyRenewalValueToPeriod[selectedValue.periodAmount]}
                    options={technologyRenewalPeriodOptions}
                    onValueChange={handlePeriodChange}
                />
            </StyledInlineFilterWrapper>
            <StyledDropdownLabelGapWrapped data-automation="technology-filter-text">
                {translate("si.signals.management.label.technology.filterSecondText")}
            </StyledDropdownLabelGapWrapped>
            <StyledInlineFilterWrapper>{children}</StyledInlineFilterWrapper>
        </StyledTechnologiesSignalFiltersWrapper>
    );
}

export default CompetitorRenewalComingUpView;
